/* eslint-disable max-len */
<template>
  <div id="app">
   <v-app light>
     <Header class="hidden-sm-and-down" />
     <HeaderMobile class="hidden-md-and-up" />
      <Impressum class=mt-5 id="impressum"/>
  </v-app>
 </div>
</template>

<script>
import Header from '../components/molecules/Header.vue';
import HeaderMobile from '../components/molecules/HeaderMobile.vue';
import Impressum from '../components/molecules/Impressum.vue';


export default {
  components: {
    Header,
    HeaderMobile,
    Impressum,
  },
  data: () => ({

  }),
};
</script>

<style>
.parallax img { width: 100%; }
</style>
